import { render, staticRenderFns } from "./recordDrawer.vue?vue&type=template&id=551421bc&"
import script from "./recordDrawer.vue?vue&type=script&lang=js&"
export * from "./recordDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports